<template>
    <div v-if="isloaded">
        <div class="container dyno-page mt-5 mb-5">

                <h4 class="page-title">{{icerik.title}}</h4>
                <div v-html="icerik.content"></div>

        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import { mdbContainer, mdbCol, mdbRow, mdbIcon, mdbTabs, mdbJumbotron, mdbView, mdbMask, mdbBtn, mdbTextarea, mdbInput, mdbCarousel, mdbCarouselItem,mdbCard, mdbCardImage, mdbCardBody, mdbCardTitle, mdbCardText, mdbCarouselCaption,mdbCollapse } from 'mdbvue';
    import searchBar from '@/components/searchBar';

    export default {
        metaInfo() {
            return {
                title: this.icerik.meta_title,
                meta: [
                    { name: 'description', content:  this.icerik.meta_description},
                    { name: 'keywords', content:  this.icerik.meta_keyword},
                    { property: 'og:title', content: this.icerik.meta_title},
                    { property: 'og:site_name', content: 'Biletbul'},
                    {property: 'og:type', content: 'website'},
                    {name: 'robots', content: 'index,follow'}
                ]
            }
        },
        components: {
            mdbContainer,
            mdbCol,
            mdbRow,
            mdbIcon,
            mdbTabs,
            mdbJumbotron,
            mdbView,
            mdbMask,
            mdbBtn,
            mdbTextarea,
            mdbInput,
            mdbCarouselItem,
            mdbCard,
            mdbCardImage,
            mdbCardBody,
            mdbCardTitle,
            mdbCardText,
            mdbCarousel,
            mdbCarouselCaption,
            mdbCollapse,
            'bb-searchbar':searchBar,
        },
        data() {
            return {
                modal: false,
                toggle: false,
                slug:this.$route.params.slug,
                isloaded : false,
                icerik:{},
            };
        },
        mounted() {
            this.getPageData();
        },
        methods:{
            getPageData(){
                axios.get("https://www.biletbul.com/backend/public/api/v1/p/"+this.slug,{
                    headers:{}
                })
                    .then((response) => {
                        this.isloaded = true;
                        if(response.data.status == true){
                            this.icerik = response.data.data;
                        }
                });
            }
        },
        watch:{
            $route(to, from) {
                this.slug=to.params.slug,
                this.getPageData();
            }

        }
    };
</script>

<style scoped>

</style>
